import { useState } from "react";
import PhoneOrderTable from "../../components/phone-order/PhoneOrderTable";
import AddNewPhoneOrder from "../../components/phone-order/AddNewPhoneOrder";

const PhoneOrder = () => {
  const [showPhoneOrderTable, setShowPhoneOrderTable] = useState(true);
  const [showAddNewPhoneOrder, setShowAddNewPhoneOrder] = useState(false);

  const changeView = (showPhoneOrderTable, showAddNewPhoneOrder) => {
    setShowPhoneOrderTable(showPhoneOrderTable);
    setShowAddNewPhoneOrder(showAddNewPhoneOrder);
  };

  return showPhoneOrderTable ? (
    <PhoneOrderTable alterComponent={changeView} />
  ) : showAddNewPhoneOrder ? (
    <AddNewPhoneOrder alterComponent={changeView} />
  ) : null;
};

export default PhoneOrder;
